<hr class="detail-section__divider" />

<section class="detail-section">
  <h4 class="detail-section__title">Escursioni in crociera</h4>
  <!-- Selezione Porto -->
  <div class="inline-select">
    <label class="inline-select__label" for="selectHarbour">
      <div class="row-icon">
        <div class="row-icon__icon">
          <i class="icon-pin"></i>
        </div>
        <div class="row-icon__text">Seleziona il Porto</div>
      </div>
    </label>
    <div class="inline-select__select">
      <ng-select
        [items]="allAvailableExcursions | excursionPorts"
        bindLabel="name"
        [searchable]="false"
        [clearable]="false"
        placeholder="Seleziona il porto..."
        class="form-control-custom"
        id="selectHarbour"
        [(ngModel)]="selectedHarbour"
      >
      </ng-select>
    </div>
  </div>

  <div class="position-relative">
    <!-- Slider Escursioni -->
    <swiper
      [config]="config"
      [(index)]="index"
      class="c-excursion-slider"
      *ngIf="selectedHarbour"
    >
      <div
        class="card-excursion"
        [ngClass]="{ active: this.selectedExcursion === excursion }"
        (click)="this.selectedExcursion = excursion"
        *ngFor="
          let excursion of allAvailableExcursions
            | filter : filterBySelectedHarbour : selectedHarbour
        "
      >
        <div
          [ngStyle]="{
            'background-image':
              'url(' +
              (excursion.harbour.code | imageByCode : 'harbour' | async) +
              ')'
          }"
          class="card-excursion__image"
        ></div>
        <div class="card-excursion__content">
          <small>{{ excursion.harbour.name }}</small>
          <h6 class="card-excursion__title">{{ excursion.title }}</h6>
          <span class="card-excursion__cod" [hidden]="!excursion.code"
            >(Cod {{ excursion.code }})</span
          >
          <div class="card-excursion__bottom">
            <div [hidden]="!excursion.duration">
              Durata: <span>{{ excursion.duration }} ore</span>
            </div>
            <div [hidden]="!excursion.level">
              Livello: <span>{{ excursion.level }}</span>
            </div>
          </div>
        </div>
      </div>
    </swiper>
  </div>
  <!-- Dettagli Escursione Selezionata -->
  <div
    class="card-excursion__detail"
    *ngIf="selectedExcursion && selectedHarbour"
  >
    <div class="card-excursion__detail-top">
      <div class="card-excursion__detail-top--title">
        <h4
          class="detail-content__title detail-content__title--color detail-content__title--cruise"
        >
          {{ selectedExcursion.title }}
        </h4>
        <span class="card-excursion__cod" [hidden]="!selectedExcursion.code"
          >(Cod {{ selectedExcursion.code }})</span
        >
      </div>
      <div class="card-excursion__detail-top--info">
        <span [hidden]="!selectedExcursion.duration"
          >Durata: <span>{{ selectedExcursion.duration }} ore</span></span
        >
        <span [hidden]="!selectedExcursion.level"
          >Livello: <span>{{ selectedExcursion.level }}</span></span
        >
      </div>
    </div>
    <div class="card-excursion__detail-content">
      <div class="detail-content__row row">
        <div class="col-12 col-lg-2">
          <h6 class="card-excursion__detail-title">Dettagli Escursione</h6>
        </div>
        <div
          class="col-12 col-lg-10"
          [innerHTML]="selectedExcursion.description"
        ></div>
      </div>
    </div>
  </div>
</section>

<hr class="detail-section__divider" />
